// extracted by mini-css-extract-plugin
export default {"content":"hY0XWxsP4H_pdp","full-screen":"Nwk9ay0zi5_pdp","curtain":"bpwJjCOdpi_pdp","container":"x7N6F2oico_pdp","sticky":"hnGKwIFOfc_pdp"};